// Module
var code = "<div class=\"flex-wrapper {{$.style.mb}}\">\n\t<div class=\"{{$.style.title}}\">План тренировок</div>\n\t<div class=\"{{$.style.wrapper}}\">\n\t\t<a class=\"{{$.style.link}}\">все сотрудники</a>\n\t\t<a class=\"{{$.style.link}}\">За все время</a>\n\t</div>\n</div>";
// Exports
export default code;